import React, { useState } from 'react'
import './home.css'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import {Link, NavLink, Route } from 'react-router-dom'
import DoctorImg from '../../assets/doctor.png'


const home = () => {

  // const [isButtonActive, setButtonActive] = useState(false);
   
  return (
    <div>
    <div className='container'>
    <div className='details'>
      <h4 className='heading'>WELCOME TO WEBSITE</h4>
      <h1 className='name'>Dr S.C Manchanda</h1>
      <h3 className='speciality'>MBBS | MD | DM - Cardiology</h3>
      <div className='multiline1'>
      <p >Subhash Chand Manchanda is an Indian cardiologist and a
      
      senior consultant of Sir Ganga Ram Hospital, New Delhi.</p>
      </div>
      <NavLink to='/contact' className='linkappointment'>
        Book An Appointment
      </NavLink>
      </div>
      <div>
        <img src={DoctorImg} alt='dr' className='doctor'/>
      </div>
    </div>
    <div className='container-2'>
    <div className='flexing'>
      <div className='whychooseus'>
        <h2 className='heading2'>Why choose us?</h2>
        <div className='para'>
          <p>Dr. Manchanda has some of the fraternity’s finest doctors and they know how to execute and fetch positive outcomes in any circumstances.</p>
        </div>
        <Link to='/contact' className='appointment-2 appointment-link'>
          Book an Appointment
        </Link>
      </div>
      <div className='features'>
        <div className='card1'>
          <div className='circle'></div>
          <h3>Medical Facilities</h3>
          <p>We deliver with medical’s best facilities so that you do not get into any medical trouble whatsoever.</p>
        </div>
        <div className='card2'>
        <div className='circle'></div>
        <h3>Experienced Doctor</h3>
        <p>Dr. Manchanda is regarded as one of the finest doctors with multiple accreditations under his name. He is skilful and has dealt with countless surgeries and medical cases.</p>
        </div>
        <div className='card3'>
        <div className='circle'></div>
        <h3>Emergency Services</h3>
        <p>We are eager to help patients who are in dire need of medical support throughout the juncture. We are always present with open arms.</p>
        </div>
      </div>
    </div>
      
    </div>

    {/* About */}
    <div className='container3'>
    
        <img src={DoctorImg} alt='doctor' className='about-image' />
      
      <div className='inner-container3'>
        <h3 className='name2'>Dr S.C Manchanda</h3>
        <p className='para3'>Dr. Subhash Chand Manchanda is a senior consultant cardiologist working at Sir Gangaram Hospital, New Delhi. He is a recipient of the prestigious Padma Shri award, which is the fourth-highest civilian award. Dr. Subhash Chand Manchanda is widely recognized for his service-oriented nature and is involved in numerous public service activities that are beneficial to society.
          </p>
      
      <div className='about'>
        <ul className='about-link' >
          <NavLink to='/education' className='about-link-link1'
            
          >
              <li>Education</li>
          </NavLink>
          <NavLink to='/' className='about-link-link2'
          style={({isActive})=>{
                return {
                    backgroundColor: isActive? "#FFDD3C" : "white"
                }
            }}
          >
              <li>Registraion</li>
          </NavLink>
          <NavLink to='/' className='about-link-link3'
          style={({isActive})=>{
                return {
                    backgroundColor: isActive? "#FFDD3C" : "white"
                }
            }}
          >
              <li>Awards</li>
          </NavLink>
        </ul>
      </div>
      </div>
    </div>

    {/* Explore Services */}
    {/* <div>
      <div className='service-heading'>
        <h3>Explore Services</h3>
      </div>
      <div className='service-subheading'>
        <h1>10+ Cardiology Services</h1>
      </div> */}

      {/* Carousel starting */}
      {/* <Carousel className='carousel'>
        <div className='carousel-card1'>
          <div>Circle</div>
          <h3>Coronary Angiography</h3>
          <p>Coronary angiography is the procedures that Dr Manchanda has been performing over the year. Through angiography...</p>
        </div>
        <div className='carousel-card2'>
          <div>Circle</div>
          <h3>Coronary Angioplasty</h3>
          <p>Coronary angioplasty performed by Dr Manchanda helps in widening the blocked and narrowed artery. It can be done throguh either ballon...</p>
        </div>
        <div className='carousel-card3'>
          <div>Circle</div>
          <h3>Peacemaker Implantation</h3>
          <p>A peacemaker is a small electronic device isserted by our doctors that help in regulating electrical impulses. Usually, the sinoatrial node present</p>
        </div>
        <div className='carousel-card4'>
          <div>Circle</div>
          <h3>ECMO Therapy</h3>
          <p>Extracorporeal Membrane Oxygenation is an exceptional therapy that delivers oxygen through the blood. It is applied for those</p>
        </div>
      </Carousel> */}

    {/* </div> */}
    </div>
  )
}

export default home